export default "__VITE_PUBLIC_ASSET__702cc480__"